import {Env} from './components/config/env';
import {Settings} from './components/config/settings';
import {Snippet} from './components/config/snippet';
import {Customization} from './components/config/customization';
import {AppConfig} from './components/config/config';

import {AppLibrary} from './components/app-library';
import {Loader} from './components/loader';

import {Application} from './components/application';

let env = new Env();
const APP_NAME = env.appName;

let settings = new Settings(APP_NAME);
let snippet = new Snippet(APP_NAME);
let customization = new Customization(APP_NAME);
let config = new AppConfig(env, settings, snippet, customization);
let library = new AppLibrary(APP_NAME, snippet);

let theGreatLoader = new Loader(library, APP_NAME);

theGreatLoader.requireJQuery('1.7', '1.9.1');

theGreatLoader.enableSelectorPicker((pageType) => {
  if (pageType === 'cart') {
    let _GET = library.requestGetVars();
    if (snippet.cartItems.length !== 1 && typeof (_GET.vid) !== 'undefined') {
      // Add exactly 1 line-item to the cart
      library.ajax('POST', '/cart/clear.js', null, () => {
        library.ajax('POST', '/cart/add.js', 'quantity=1&id=' + _GET.vid, () => {
          document.location.reload();
        });
      });
      return false;
    }
  }
  return true;
});

theGreatLoader.addResources(env.awsCommonPath + 'common.css');
theGreatLoader.addResources(env.awsStorePath + snippet.shopHash + '.js');
theGreatLoader.addResources(env.awsStorePath + snippet.shopHash + '.css');
theGreatLoader.addResources(env.spuritGlobalPath);

theGreatLoader.run(($, currentPage) => {
  Spurit.global.onReady(
      ['cart', 'selectors', 'checkout', 'prices'],
      () => {
        // Run App
        config.init();
        new Application($, config, library, currentPage);
      },
      {
        checkout: {
          hash: config.snippet().shopHash,
          app_id: config.snippet().appId,
          app_name: config.snippet().appName,
        }
      }
  );
});